import React, { useState } from "react";
import Layouts from "../../config/layouts/Layouts";
import NavbarComponent from "../navbar/Navbar";
import Footer from "../footer/Footer";

const initialForm = {
    nombre: "",
    email: "",
    asunto: "",
    mensaje: "",
};

function Contacto() {
    const [form, setForm] = useState(initialForm);
    const [enviado, setEnviado] = useState(false);
    const [error, setError] = useState("");

    function handleChange(e) {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        setError("");
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!form.nombre.trim() || !form.email.trim() || !form.mensaje.trim()) {
            setError("Completa nombre, correo y mensaje.");
            return;
        }
        setEnviado(true);
        setForm(initialForm);
    }

    return (
        <Layouts>
            <header className="shrink-0">
                <NavbarComponent />
            </header>

            <main className="min-h-screen bg-em-bg pb-[calc(4rem+var(--em-footer-h))] pt-32 text-em-text sm:pt-36 md:pt-40 font-[Inter,system-ui,sans-serif]">
                <div className="mx-auto max-w-6xl px-5 md:px-8">
                    <div className="mb-12 text-center md:text-left md:pt-2">
                        <p className="mb-3 inline-block rounded-full border border-em-accent2/30 bg-em-accent2/10 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-em-accent2">
                            Hablemos
                        </p>
                        <h1 className="text-4xl font-black tracking-tight text-em-text md:text-5xl">
                            Contacto
                        </h1>
                        <p className="mt-4 max-w-2xl text-lg text-em-soft">
                            Cuéntanos tu proyecto o tu duda. Te responderemos lo antes posible.
                        </p>
                    </div>

                    <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr]">
                        <div className="space-y-6">
                            <div className="rounded-2xl border border-em-text/10 bg-em-card p-6 shadow-xl">
                                <h2 className="mb-4 text-sm font-bold uppercase tracking-wide text-em-accent">
                                    Datos
                                </h2>
                                <ul className="space-y-4 text-em-soft">
                                    <li className="flex gap-3">
                                        <span className="mt-0.5 text-em-accent" aria-hidden>
                                            ✉
                                        </span>
                                        <div>
                                            <p className="text-xs font-semibold uppercase text-em-muted">
                                                Correo
                                            </p>
                                            <a
                                                href="mailto:emmpieza@gmail.com"
                                                className="text-em-text underline-offset-2 hover:text-em-accent hover:underline"
                                            >
                                                emmpieza@gmail.com
                                            </a>
                                        </div>
                                    </li>
                                    <li className="flex gap-3">
                                        <span className="mt-0.5 text-em-accent" aria-hidden>
                                            ◎
                                        </span>
                                        <div>
                                            <p className="text-xs font-semibold uppercase text-em-muted">
                                                Respuesta
                                            </p>
                                            <p className="text-em-soft">
                                                Lunes a viernes, en horario laboral.
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <p className="text-sm text-em-muted">
                                Si prefieres, vuelve al inicio y usa el enlace directo a esta sección desde el menú.
                            </p>
                        </div>

                        <div className="rounded-2xl border border-em-text/10 bg-em-card p-6 shadow-xl md:p-8">
                            {enviado ? (
                                <div
                                    className="flex flex-col items-center justify-center py-12 text-center"
                                    role="status"
                                >
                                    <p className="mb-2 text-2xl font-bold text-em-text">
                                        Mensaje recibido
                                    </p>
                                    <p className="max-w-sm text-em-soft">
                                        Gracias por escribirnos. Cuando conectes un backend o un servicio de
                                        correo, podrás enviar este formulario de verdad.
                                    </p>
                                    <button
                                        type="button"
                                        onClick={() => setEnviado(false)}
                                        className="mt-8 rounded-full border border-em-text/20 px-6 py-2.5 text-sm font-semibold text-em-text transition hover:border-em-accent/50 hover:bg-em-text/5"
                                    >
                                        Enviar otro mensaje
                                    </button>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit} className="space-y-5" noValidate>
                                    <div>
                                        <label
                                            htmlFor="contacto-nombre"
                                            className="mb-1.5 block text-sm font-medium text-em-soft"
                                        >
                                            Nombre
                                        </label>
                                        <input
                                            id="contacto-nombre"
                                            name="nombre"
                                            type="text"
                                            autoComplete="name"
                                            value={form.nombre}
                                            onChange={handleChange}
                                            className="w-full rounded-xl border border-em-text/10 bg-em-bg px-4 py-3 text-em-text placeholder:text-em-muted focus:border-em-accent/60 focus:outline-none focus:ring-2 focus:ring-em-accent/30"
                                            placeholder="Tu nombre"
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="contacto-email"
                                            className="mb-1.5 block text-sm font-medium text-em-soft"
                                        >
                                            Correo
                                        </label>
                                        <input
                                            id="contacto-email"
                                            name="email"
                                            type="email"
                                            autoComplete="email"
                                            value={form.email}
                                            onChange={handleChange}
                                            className="w-full rounded-xl border border-em-text/10 bg-em-bg px-4 py-3 text-em-text placeholder:text-em-muted focus:border-em-accent/60 focus:outline-none focus:ring-2 focus:ring-em-accent/30"
                                            placeholder="tu@correo.com"
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="contacto-asunto"
                                            className="mb-1.5 block text-sm font-medium text-em-soft"
                                        >
                                            Asunto{" "}
                                            <span className="font-normal text-em-muted">(opcional)</span>
                                        </label>
                                        <input
                                            id="contacto-asunto"
                                            name="asunto"
                                            type="text"
                                            value={form.asunto}
                                            onChange={handleChange}
                                            className="w-full rounded-xl border border-em-text/10 bg-em-bg px-4 py-3 text-em-text placeholder:text-em-muted focus:border-em-accent/60 focus:outline-none focus:ring-2 focus:ring-em-accent/30"
                                            placeholder="Ej. Consulta sobre un proyecto"
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="contacto-mensaje"
                                            className="mb-1.5 block text-sm font-medium text-em-soft"
                                        >
                                            Mensaje
                                        </label>
                                        <textarea
                                            id="contacto-mensaje"
                                            name="mensaje"
                                            rows={5}
                                            value={form.mensaje}
                                            onChange={handleChange}
                                            className="w-full resize-y rounded-xl border border-em-text/10 bg-em-bg px-4 py-3 text-em-text placeholder:text-em-muted focus:border-em-accent/60 focus:outline-none focus:ring-2 focus:ring-em-accent/30"
                                            placeholder="Describe lo que necesitas..."
                                        />
                                    </div>

                                    {error ? (
                                        <p className="text-sm text-rose-400" role="alert">
                                            {error}
                                        </p>
                                    ) : null}

                                    <button
                                        type="submit"
                                        className="w-full rounded-full bg-gradient-to-r from-em-vivid to-em-vivid2 py-3.5 text-center text-sm font-semibold text-em-ink shadow-lg shadow-em-vivid/25 transition hover:opacity-95 md:w-auto md:px-10"
                                    >
                                        Enviar mensaje
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </Layouts>
    );
}

export default Contacto;
